import {FC} from 'react';
import {StyleSheet, Document, Page, View, Font} from '@react-pdf/renderer';
import Header from './Header';
import ProjectTotals from './ProjectTotals';
import PageCounter from './PageCounter';
import LocationGallery from './LocationGallery';
import LocationsNotes from './LocationsNotes';
import LocationResources from './LocationResources';
import LocationCollectedWeight from './LocationCollectedWeight';
import LocationCollectedCategories from './LocationCollectedCategories';
import LocationBasicInfo from './LocationBasicInfo';
import LocationHeader from './LocationHeader';
import {IPDFReportData} from '../../../models/pdfReport';
import {format} from 'date-fns';
import CleanupsSummaryTable from './CleanupsSummaryTable';
import Roboto from '../../../assets/fonts/Roboto-Regular.ttf';


Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: Roboto,
            fontWeight: 'normal',
        },
        {
            src: Roboto,
            fontWeight: 'bold',
        },
        {
            src: Roboto,
            fontStyle: 'italic',
        },
    ]
});

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        padding: '20pt',
    },
});

interface IProps {
    data: IPDFReportData;
}

const DailyReportPDF: FC<IProps> = ({data}) => {
    return (
        <Document title={`Report of ${format(new Date(data.date), 'MMMM do, yyyy')}`}>
            <Page size="A4" style={styles.page}>
                <Header date={data.date} />
                {data.projects.map((project, index) => (
                    <View key={project.name} break={index !== 0}>
                        <CleanupsSummaryTable data={project} />
                        <ProjectTotals data={project} />
                        {project.cleanUps.map((cleanUp) => (
                            <View key={cleanUp.id} break>
                                <LocationHeader data={cleanUp} />
                                <LocationBasicInfo data={cleanUp} />
                                <LocationCollectedWeight data={cleanUp} />
                                <LocationCollectedCategories data={cleanUp} />
                                <LocationResources data={cleanUp.usedResources} />
                                <LocationsNotes notes={cleanUp.notes} />
                                <LocationGallery spots={cleanUp.images} />
                            </View>
                        ))}
                    </View>
                ))}

                <PageCounter />
            </Page>
        </Document>
    );
};

export default DailyReportPDF;
